import commonSimplifiedChinese from "./common.json";
import customerSimplifiedChinese from "./customers.json";
import dashboardSimplifiedChinese from "./dashboard.json";
import embeddedSimplifiedChinese from "./embedded.json";
import navigationSimplifiedChinese from "./navigation.json";
import notificationSimplifiedChinese from "./notifications.json";
import reportSimplifiedChinese from "./reports.json";
import settingsSimplifiedChinese from "./settings.json";
import sharedSimplifiedChinese from "./shared.json";
import ticketSimplifiedChinese from "./tickets.json";

export const simplifiedChineseJson = {
  ...commonSimplifiedChinese,
  ...customerSimplifiedChinese,
  ...dashboardSimplifiedChinese,
  ...embeddedSimplifiedChinese,
  ...navigationSimplifiedChinese,
  ...notificationSimplifiedChinese,
  ...reportSimplifiedChinese,
  ...settingsSimplifiedChinese,
  ...sharedSimplifiedChinese,
  ...ticketSimplifiedChinese,
};
